export interface AvatarProps {
  name: string;
  src?: string | null;
  size?: number;
}

export function Avatar({ name, src, size = 40 }: AvatarProps) {
  const initial = name.trim().charAt(0).toUpperCase() || "?";
  const style = { width: size, height: size, fontSize: size * 0.4 };

  if (src) {
    return (
      <img
        className="jaiho-avatar"
        style={style}
        src={src}
        alt={name}
        referrerPolicy="no-referrer"
      />
    );
  }

  return (
    <div className="jaiho-avatar jaiho-avatar--fallback" style={style}>
      {initial}
    </div>
  );
}
